// extracted by mini-css-extract-plugin
export var dividerLine = "_4f-0";
export var errorBackground = "_4f-1";